import React, { Component } from "react";
import { RichText } from "prismic-reactjs";
import { linkResolver } from "../../prismic-configuration";
import { connect } from "react-redux";
import {
  fetchEvent,
  fetchEvents,
  fetchYearOfActionResources,
  fetchYearOfActionPage
} from "../../store/actions";
import { YearOfActionResource } from "../YearOfActionResource";
import { Event } from "../Event";

class EventItemPage extends Component {
  componentDidMount() {
    this.props.fetchEvent(this.props.match.params.uid);
    this.props.fetchEvents({ pageSize: 3 });
    this.props.fetchYearOfActionResources();
    this.props.fetchYearOfActionPage();
  }

  renderMoreEvents = () => {
    const { event } = this.props;
    const { entity, list } = event;

    if (entity && list) {
      const otherEvents = list.results.filter(item => item.id !== entity.id);
      return otherEvents.map(item => {
        return <Event key={item.id} event={item} />;
      });
    } else {
      return;
    }
  };

  render() {
    const { event, yearOfActionResource } = this.props;
    const { entity } = event;

    return (
      <React.Fragment>
        {entity && (
          <React.Fragment>
            {this.props.yearOfAction.entity &&
            this.props.yearOfAction.entity.data.banner.url ? (
              <div
                className="hero-unit year-of-action"
                style={{
                  backgroundImage: `url(${this.props.yearOfAction.entity.data.banner.url})`
                }}
              ></div>
            ) : (
              <div className="pt-5" />
            )}
            <div className="container">
              <div className="row">
                <div className="col-12 col-md-8 col-lg-7 pt-5 pb-5 pr-md-5 order-md-first">
                  <h2 className="text-uppercase">
                    {RichText.asText(entity.data.title)}
                  </h2>
                  <div className="content">
                    {RichText.render(entity.data.content, linkResolver)}
                  </div>

                  {this.renderMoreEvents()}
                </div>

                {yearOfActionResource.list && (
                  <div className="col-12 col-md-5 pt-5 pb-5 event-resources">
                    <div className="position-relative pl-md-5">
                      <h2 className="mb text-black">Resources</h2>

                      {yearOfActionResource.list.results.map(item => (
                        <YearOfActionResource item={item} key={item.id} />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  event: state.event,
  yearOfActionResource: state.yearOfActionResource,
  yearOfAction: state.yearOfAction
});

export default connect(mapStateToProps, {
  fetchEvent,
  fetchEvents,
  fetchYearOfActionResources,
  fetchYearOfActionPage
})(EventItemPage);



// WEBPACK FOOTER //
// ./src/components/pages/EventItemPage.js